import React from 'react';
import { FolderOpen, History, PlusCircle, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { buildRoleWorkspaceNavItems } from '../config/roleWorkspaceConfig';
import RoleLayoutShell from './RoleLayoutShell';

const UserLayout = () => {
  const auth = useAuth();
  const navItems = buildRoleWorkspaceNavItems('employee', auth).map((item) => ({
    ...item,
    Icon: item.to === '/dashboard' ? FolderOpen : item.to === '/transactions' ? PlusCircle : item.to === '/history-analytics' ? History : User,
    anyPermissions: item.permission,
  }));

  return <RoleLayoutShell title="EMS" subtitle="Employee Workspace" navItems={navItems} />;
};

export default UserLayout;
